import { ProSidebar, Menu, SubMenu, MenuItem, SidebarHeader, SidebarContent, SidebarFooter } from 'react-pro-sidebar';
import { CgProfile } from 'react-icons/cg';
import { FaTachometerAlt, FaBuilding, FaUser, FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import React, { useContext } from 'react';
import AuthProvider from '../guards/AuthProvider.js';
import { decodeToken } from "react-jwt";
import logoutUtil from '../utils/logout.js';

const sidebarStyle = {
    height: '150%'
}

function Sidebar() {
    const [auth, setAuth] = useContext(AuthProvider);

    const isLoggedIn = () => {
        if (auth) {
            return true
        } else {
            return false
        }
    }

    const isSuperAdmin = () => {
        if (auth && decodeToken(auth.token).role === 'super admin') {
            return true
        } else {
            return false
        }
    }

    const renderSuper = () => {
        return (
            <Menu iconShape="circle">
                <SubMenu
                    icon={<FaBuilding />}
                    title="Gedung"
                >
                    <MenuItem>
                        Tambah gedung
                        <Link to="/create_building" />
                    </MenuItem>
                    <MenuItem>
                        Daftar gedung
                        <Link to="/list_building" />
                    </MenuItem>
                </SubMenu>
                <SubMenu
                    icon={<FaUser />}
                    title="Pengguna"
                >
                    <MenuItem>
                        Daftar pengguna
                        <Link to="/list_role" />
                    </MenuItem>
                </SubMenu>
            </Menu>
        )
    }

    const renderLoggedIn = () => {
        return (
            <Menu iconShape="circle">
                <MenuItem icon={<FaTachometerAlt />}>
                    Dashboard
                    <Link to="/dashboard" />
                </MenuItem>
                <MenuItem icon={<FaSignOutAlt />}>
                    Sign Out
                    <Link to="/logout"/>
                </MenuItem>
            </Menu>
        )
    }

    return (
        <div className="sidebar">
            <ProSidebar
                breakPoint="md"
                style={sidebarStyle}
            >
                <SidebarHeader>
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<CgProfile size={70} />}
                            style={{
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                fontSize: 14,
                                letterSpacing: '1px',
                            }}>Profile</MenuItem>
                    </Menu>
                </SidebarHeader>
                <SidebarContent>
                
                {
                    isSuperAdmin()
                    ? renderSuper()
                    : null
                }
                {
                    isLoggedIn()
                    ? renderLoggedIn()
                    : null
                }
                </SidebarContent>
                <SidebarFooter style={{ textAlign: 'center' }}>
                    <p>logo itb?</p>
                </SidebarFooter>
            </ProSidebar>
        </div>
    );
}

export default Sidebar;
